import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import ModalAvisos from './components/ModalAvisos';

import Landing         from './pages/Landing';
import Login           from './pages/Login';
import SeleccionTipo   from './pages/SeleccionTipo';
import PagoAcceso      from './pages/PagoAcceso';
import PagoExito       from './pages/PagoExito';
import AdminPanel               from './pages/admin/AdminPanel';
import ProfesorPanel            from './pages/profesor/ProfesorPanel';
import AdminUsuarios            from './pages/admin/AdminUsuarios';
import AdminStripe              from './pages/admin/AdminStripe';
import AdminAccesosTemporales   from './pages/admin/AdminAccesosTemporales';
import AdminAvisos              from './pages/admin/AdminAvisos';
import AdminSeguridad           from './pages/admin/AdminSeguridad';
import CambiarPasswordForzado   from './pages/admin/CambiarPasswordForzado';

import Aprendizaje     from './pages/Aprendizaje';
import Temario         from './pages/secciones/Temario';
import Actividades     from './pages/secciones/Actividades';
import CrearEvaluacion  from './pages/secciones/CrearEvaluacion';
import EditarEvaluacion from './pages/secciones/EditarEvaluacion';
import EvaluacionVer   from './pages/secciones/EvaluacionVer';
import Plantillas      from './pages/secciones/Plantillas';
import ClasesOnline    from './pages/secciones/ClasesOnline';
import ClasesGrabadas  from './pages/secciones/ClasesGrabadas';
import HallFama        from './pages/secciones/HallFama';
import Calendario      from './pages/secciones/Calendario';

const NIVELES = { militar: ['SLP2','SLP3','SLP4','ACCESO_SUBOFICIAL','ACCESO_OFICIAL','CURSO_SUBOFICIAL','CURSO_OFICIAL'], civil: ['B1','B2','C1','C2'] };

function Privada({ children, soloAdmin }) {
  const { usuario, cargando } = useAuth();
  if (cargando) return <div style={{ minHeight: '100vh', background: '#FFF0F5' }} />;
  if (!usuario) return <Navigate to="/login" replace />;
  if (usuario.forzar_cambio_password) return <Navigate to="/cambiar-password-forzado" replace />;
  if (soloAdmin && usuario.rol !== 'admin') return <Navigate to="/seleccion" replace />;
  return children;
}

function PrivadaSeccion({ tipo, children }) {
  const { usuario, cargando } = useAuth();
  const { nivel } = useParams();
  if (cargando) return <div style={{ minHeight: '100vh', background: '#FFF0F5' }} />;
  if (!usuario) return <Navigate to="/login" replace />;

  const esProfesor = ['profesor','admin'].includes(usuario.rol);
  if (esProfesor) return children;

  // Alumno sin suscripción activa → siempre a pagar
  if (!usuario.suscripcion_activa) return <Navigate to="/pagar" replace />;

  const accesos = usuario.accesos || [];
  const tieneAccesoTipo = accesos.some(a => a.tipo === tipo);
  if (!tieneAccesoTipo) return <Navigate to="/seleccion" replace />;

  const nivelesAccesibles = accesos.filter(a => a.tipo === tipo).map(a => a.nivel);
  if (nivel && !nivelesAccesibles.includes(nivel)) {
    return <Navigate to={nivelesAccesibles.length > 0 ? `/${tipo}/${nivelesAccesibles[0]}/temario` : '/seleccion'} replace />;
  }

  return children;
}

// Páginas Militar
function MilitarTemario()         { const { nivel } = useParams(); return <PrivadaSeccion tipo="militar"><Temario tipo="militar" nivel={nivel} /></PrivadaSeccion>; }
function MilitarActividades()     { const { nivel } = useParams(); return <PrivadaSeccion tipo="militar"><Actividades tipo="militar" nivel={nivel} /></PrivadaSeccion>; }
function MilitarCrearEval()       { const { nivel } = useParams(); return <PrivadaSeccion tipo="militar"><CrearEvaluacion tipo="militar" nivel={nivel} subtipo="examen" /></PrivadaSeccion>; }
function MilitarCrearActividad()  { const { nivel } = useParams(); return <PrivadaSeccion tipo="militar"><CrearEvaluacion tipo="militar" nivel={nivel} subtipo="actividad" /></PrivadaSeccion>; }
function MilitarPlantillas()      { const { nivel } = useParams(); return <PrivadaSeccion tipo="militar"><Plantillas tipo="militar" nivel={nivel} /></PrivadaSeccion>; }
function MilitarEditarEval()      { const { nivel, id } = useParams(); return <PrivadaSeccion tipo="militar"><EditarEvaluacion tipo="militar" nivel={nivel} evalId={id} /></PrivadaSeccion>; }
function MilitarEval()          { const { nivel, id } = useParams(); return <PrivadaSeccion tipo="militar"><EvaluacionVer tipo="militar" nivel={nivel} evalId={id} modo="test" /></PrivadaSeccion>; }
function MilitarEvalResultados(){ const { nivel, id } = useParams(); return <PrivadaSeccion tipo="militar"><EvaluacionVer tipo="militar" nivel={nivel} evalId={id} modo="resultados" /></PrivadaSeccion>; }
function MilitarClasesOnline()  { const { nivel } = useParams(); return <PrivadaSeccion tipo="militar"><ClasesOnline tipo="militar" nivel={nivel} /></PrivadaSeccion>; }
function MilitarClasesGrab()    { const { nivel } = useParams(); return <PrivadaSeccion tipo="militar"><ClasesGrabadas tipo="militar" nivel={nivel} /></PrivadaSeccion>; }
function MilitarHallFama()      { const { nivel } = useParams(); return <PrivadaSeccion tipo="militar"><HallFama tipo="militar" nivel={nivel} /></PrivadaSeccion>; }
function MilitarCalendario()    { const { nivel } = useParams(); return <PrivadaSeccion tipo="militar"><Calendario tipo="militar" nivel={nivel} /></PrivadaSeccion>; }

// Páginas Civil
function CivilTemario()           { const { nivel } = useParams(); return <PrivadaSeccion tipo="civil"><Temario tipo="civil" nivel={nivel} /></PrivadaSeccion>; }
function CivilActividades()       { const { nivel } = useParams(); return <PrivadaSeccion tipo="civil"><Actividades tipo="civil" nivel={nivel} /></PrivadaSeccion>; }
function CivilCrearEval()         { const { nivel } = useParams(); return <PrivadaSeccion tipo="civil"><CrearEvaluacion tipo="civil" nivel={nivel} subtipo="examen" /></PrivadaSeccion>; }
function CivilCrearActividad()    { const { nivel } = useParams(); return <PrivadaSeccion tipo="civil"><CrearEvaluacion tipo="civil" nivel={nivel} subtipo="actividad" /></PrivadaSeccion>; }
function CivilPlantillas()        { const { nivel } = useParams(); return <PrivadaSeccion tipo="civil"><Plantillas tipo="civil" nivel={nivel} /></PrivadaSeccion>; }
function CivilEditarEval()        { const { nivel, id } = useParams(); return <PrivadaSeccion tipo="civil"><EditarEvaluacion tipo="civil" nivel={nivel} evalId={id} /></PrivadaSeccion>; }
function CivilEval()            { const { nivel, id } = useParams(); return <PrivadaSeccion tipo="civil"><EvaluacionVer tipo="civil" nivel={nivel} evalId={id} modo="test" /></PrivadaSeccion>; }
function CivilEvalResultados()  { const { nivel, id } = useParams(); return <PrivadaSeccion tipo="civil"><EvaluacionVer tipo="civil" nivel={nivel} evalId={id} modo="resultados" /></PrivadaSeccion>; }
function CivilClasesOnline()    { const { nivel } = useParams(); return <PrivadaSeccion tipo="civil"><ClasesOnline tipo="civil" nivel={nivel} /></PrivadaSeccion>; }
function CivilClasesGrab()      { const { nivel } = useParams(); return <PrivadaSeccion tipo="civil"><ClasesGrabadas tipo="civil" nivel={nivel} /></PrivadaSeccion>; }
function CivilHallFama()        { const { nivel } = useParams(); return <PrivadaSeccion tipo="civil"><HallFama tipo="civil" nivel={nivel} /></PrivadaSeccion>; }
function CivilCalendario()      { const { nivel } = useParams(); return <PrivadaSeccion tipo="civil"><Calendario tipo="civil" nivel={nivel} /></PrivadaSeccion>; }

function Inicio() {
  const { usuario, cargando } = useAuth();
  if (cargando) return <div style={{ minHeight: '100vh', background: '#FFF0F5' }} />;
  if (!usuario) return <Landing />;
  if (usuario.rol === 'admin') return <Navigate to="/admin" replace />;
  if (usuario.rol === 'alumno' && !usuario.suscripcion_activa) return <Navigate to="/pagar" replace />;
  return <Navigate to="/seleccion" replace />;
}

// Bloqueo global: alumno sin suscripción que intenta acceder a /seleccion
function PrivadaAlumnoActivo({ children }) {
  const { usuario, cargando } = useAuth();
  if (cargando) return <div style={{ minHeight: '100vh', background: '#FFF0F5' }} />;
  if (!usuario) return <Navigate to="/login" replace />;
  if (usuario.rol === 'alumno' && !usuario.suscripcion_activa) return <Navigate to="/pagar" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/"           element={<Inicio />} />
      <Route path="/login"      element={<Login />} />
      <Route path="/seleccion"  element={<PrivadaAlumnoActivo><Privada><SeleccionTipo /></Privada></PrivadaAlumnoActivo>} />
      <Route path="/pagar"      element={<Privada><PagoAcceso /></Privada>} />
      <Route path="/pago-exitoso" element={<Privada><PagoExito /></Privada>} />

      {/* Profesor / Admin */}
      <Route path="/aprendizaje"     element={<Privada><Aprendizaje /></Privada>} />
      <Route path="/profesor"        element={<Privada><ProfesorPanel /></Privada>} />

      {/* Admin */}
      <Route path="/admin"                       element={<Privada soloAdmin><AdminPanel /></Privada>} />
      <Route path="/admin/usuarios"             element={<Privada soloAdmin><AdminUsuarios /></Privada>} />
      <Route path="/admin/pagos"                element={<Privada soloAdmin><AdminStripe /></Privada>} />
      <Route path="/admin/accesos-temporales"   element={<Privada soloAdmin><AdminAccesosTemporales /></Privada>} />
      <Route path="/admin/avisos"               element={<Privada soloAdmin><AdminAvisos /></Privada>} />
      <Route path="/admin/seguridad"            element={<Privada soloAdmin><AdminSeguridad /></Privada>} />
      <Route path="/cambiar-password-forzado"   element={<Privada><CambiarPasswordForzado /></Privada>} />

      {/* Militar */}
      <Route path="/militar"                                   element={<Navigate to="/militar/SLP2/temario" replace />} />
      <Route path="/militar/:nivel/temario"                    element={<MilitarTemario />} />
      <Route path="/militar/:nivel/actividades"                element={<MilitarActividades />} />
      <Route path="/militar/:nivel/crear-evaluacion"           element={<MilitarCrearEval />} />
      <Route path="/militar/:nivel/crear-actividad"            element={<MilitarCrearActividad />} />
      <Route path="/militar/:nivel/plantillas"                  element={<MilitarPlantillas />} />
      <Route path="/militar/:nivel/editar-evaluacion/:id"      element={<MilitarEditarEval />} />
      <Route path="/militar/:nivel/evaluacion/:id"             element={<MilitarEval />} />
      <Route path="/militar/:nivel/evaluacion/:id/resultados"  element={<MilitarEvalResultados />} />
      <Route path="/militar/:nivel/clases-online"              element={<MilitarClasesOnline />} />
      <Route path="/militar/:nivel/clases-grabadas"            element={<MilitarClasesGrab />} />
      <Route path="/militar/:nivel/hall-fama"                   element={<MilitarHallFama />} />
      <Route path="/militar/:nivel/calendario"                  element={<MilitarCalendario />} />

      {/* Civil */}
      <Route path="/civil"                                     element={<Navigate to="/civil/B1/temario" replace />} />
      <Route path="/civil/:nivel/temario"                      element={<CivilTemario />} />
      <Route path="/civil/:nivel/actividades"                  element={<CivilActividades />} />
      <Route path="/civil/:nivel/crear-evaluacion"             element={<CivilCrearEval />} />
      <Route path="/civil/:nivel/crear-actividad"              element={<CivilCrearActividad />} />
      <Route path="/civil/:nivel/plantillas"                    element={<CivilPlantillas />} />
      <Route path="/civil/:nivel/editar-evaluacion/:id"        element={<CivilEditarEval />} />
      <Route path="/civil/:nivel/evaluacion/:id"               element={<CivilEval />} />
      <Route path="/civil/:nivel/evaluacion/:id/resultados"    element={<CivilEvalResultados />} />
      <Route path="/civil/:nivel/clases-online"                element={<CivilClasesOnline />} />
      <Route path="/civil/:nivel/clases-grabadas"              element={<CivilClasesGrab />} />
      <Route path="/civil/:nivel/hall-fama"                     element={<CivilHallFama />} />
      <Route path="/civil/:nivel/calendario"                    element={<CivilCalendario />} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ModalAvisos />
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
